import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs/index';
import {Action} from '@ngrx/store';
import {YearsService} from '../services/yearsService/years.service';
import * as YearsActions from '../actions/YearsActions';
import {catchError, exhaustMap, map, of} from 'rxjs';

@Injectable()
export class YearEffects {
  update$ = createEffect(() => this.actions$.pipe(
    ofType(YearsActions.retrieveYearsAction),
    map(action => action),
    exhaustMap(() =>
      this.yearsService.retrieveYears()
        .pipe(
          map(yearArr => YearsActions.yearsReceivedAction({
            years:
              yearArr.map((y: number) => {
                return {year: y};
              })
          })),
          catchError((error: any) => of(YearsActions.retrieveYearsErrorAction({error})))
        )
    )
  ));

  constructor(
    private yearsService: YearsService,
    private actions$: Actions
  ) {
  }
}
